// Types
export const Types = {
  GET_CONSUMPTION_SYSTEMS: 'GET_CONSUMPTION_SYSTEMS',
  GET_SOURCE_SYSTEMS: 'GET_SOURCE_SYSTEMS',
  GET_PAGED_SYSTEMS: 'GET_PAGED_SYSTEMS',
  GET_SYSTEM: 'GET_SYSTEM',
  GET_USER_SYSTEMS_AVAILABLE: 'GET_USER_SYSTEMS_AVAILABLE',
  CREATE_SYSTEMS: 'CREATE_SYSTEMS',
  UPDATE_SYSTEM: 'UPDATE_SYSTEM',
  DELETE_SYSTEM: 'DELETE_SYSTEM',
  SET_LOADING: "SET_LOADING_SYSTEM",
};

// Reducer
const initialState = {
  consumptionSystems: null,
  sourceSystems: null,
  pagedSystems: null,
  system: null,
  catalogSystemsAvailable: null,

  loading: false,
};

const Systems = (state=initialState, action) => {
  switch (action.type) {
    case Types.GET_CONSUMPTION_SYSTEMS:
      return {
        ...state,
        consumptionSystems: action.payload,
        loading: false,
      }
    case Types.GET_SOURCE_SYSTEMS:
      return {
        ...state,
        sourceSystems: action.payload,
        loading: false,
      }
    case Types.GET_PAGED_SYSTEMS:
      return {
        ...state,
        pagedSystems: action.payload,
        loading: false,
      }
    case Types.GET_SYSTEM:
        return {
          ...state,
          system: action.payload,
          loading: false,
        }
    case Types.CREATE_SYSTEMS:
      return {
        ...state,
        // system: action.payload,
        loading: false,
      }
    case Types.UPDATE_SYSTEM:
      return {
        ...state,
        // system: action.payload,
        loading: false,
      }
    case Types.DELETE_SYSTEM:
      return {
        ...state,
        // system: action.payload,
        loading: false,
      }
    case Types.GET_USER_SYSTEMS_AVAILABLE:
      return {
        ...state,
        catalogSystemsAvailable: action.payload,
        loading: false,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }
    default: return state;
  }
};

export default Systems;
